export default function getHistoricalFlowRate(historicalFlowRates, startOfHalfHour) {
  const matchingTimestamp = historicalFlowRates.filter(
    ({ timestamp }) => timestamp.getTime() === startOfHalfHour.valueOf()
  );
  if (matchingTimestamp.length !== 0) {
    return matchingTimestamp[0];
  }
  return null;
}